// ═══════════════════════════════════════════
//  SKELETON — glass shimmer
// ═══════════════════════════════════════════
const variantStyles = {
  text: 'h-3 rounded',
  title: 'h-4 w-3/5 rounded',
  avatar: 'rounded-full',
  button: 'h-8 w-20 rounded-lg',
  badge: 'h-5 w-14 rounded-md',
  image: 'rounded-xl aspect-video',
  card: 'h-32 rounded-xl',
  'input': 'h-9 rounded-lg',
  circle: 'rounded-full',
  rect: 'rounded-lg',
};

const Skeleton = ({
  variant = 'text',
  width,
  height,
  className = '',
  count = 1,
  gap = 6,
}) => {
  const items = Array.from({ length: count });

  return (
    <>
      {items.map((_, i) => (
        <div
          key={i}
          className={`relative overflow-hidden bg-surface-200/50 ${variantStyles[variant] || 'rounded'} ${className}`}
          style={{
            width: width || (variant === 'avatar' || variant === 'circle' ? 32 : undefined),
            height: height || (variant === 'avatar' || variant === 'circle' ? 32 : undefined),
            marginTop: i > 0 ? gap : undefined,
          }}
        >
          <div
            className="absolute inset-0 -translate-x-full animate-shimmer"
            style={{
              backgroundImage:
                'linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent)',
            }}
          />
        </div>
      ))}
    </>
  );
};

// ═══ COMPOUND PRESETS ═══

Skeleton.Card = ({ className = '' }) => (
  <div className={`card p-4 space-y-3 ${className}`}>
    <div className="flex items-center gap-2.5">
      <Skeleton variant="avatar" width={28} height={28} />
      <div className="flex-1 space-y-1.5">
        <Skeleton variant="text" width="50%" />
        <Skeleton variant="text" width="30%" height={8} />
      </div>
    </div>
    <Skeleton variant="text" count={2} />
    <Skeleton variant="text" width="65%" />
  </div>
);

Skeleton.Table = ({ rows = 4, cols = 4, className = '' }) => (
  <div className={`card overflow-hidden ${className}`}>
    <div className="bg-surface-50/60 px-3 py-2.5 flex gap-3 border-b border-surface-100">
      {Array.from({ length: cols }).map((_, i) => (
        <Skeleton key={i} variant="text" width={`${18 + Math.random() * 15}%`} height={10} />
      ))}
    </div>
    {Array.from({ length: rows }).map((_, r) => (
      <div key={r} className="px-3 py-2.5 flex gap-3 border-b border-surface-100/60 last:border-0">
        {Array.from({ length: cols }).map((_, c) => (
          <Skeleton key={c} variant="text" width={`${15 + Math.random() * 20}%`} />
        ))}
      </div>
    ))}
  </div>
);

Skeleton.List = ({ items = 4, className = '' }) => (
  <div className={`space-y-2 ${className}`}>
    {Array.from({ length: items }).map((_, i) => (
      <div key={i} className="flex items-center gap-2.5 p-2">
        <Skeleton variant="avatar" width={28} height={28} />
        <div className="flex-1 space-y-1.5">
          <Skeleton variant="text" width={`${40 + Math.random() * 30}%`} />
          <Skeleton variant="text" width={`${25 + Math.random() * 20}%`} height={8} />
        </div>
      </div>
    ))}
  </div>
);

Skeleton.Stats = ({ count = 4, className = '' }) => (
  <div className={`grid gap-3 ${className}`} style={{ gridTemplateColumns: `repeat(${count}, 1fr)` }}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="card p-3 space-y-2">
        <Skeleton variant="text" width="45%" height={10} />
        <Skeleton variant="text" width="35%" height={18} />
      </div>
    ))}
  </div>
);

Skeleton.Profile = ({ className = '' }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <Skeleton variant="avatar" width={40} height={40} />
    <div className="space-y-1.5">
      <Skeleton variant="text" width={100} />
      <Skeleton variant="text" width={140} height={10} />
    </div>
  </div>
);

export default Skeleton;
